import { Injectable, Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './settings.service';
import { environment } from '@env/environment';
import {SentryErrorService} from "@shared/services/sentry-error.service";

@Injectable({
  providedIn: 'root',
})
export class TranslateLangService {
  constructor(
    private injector: Injector,
    private translate: TranslateService,
    private settings: SettingsService
  ) {
  }

  load() {
    return new Promise<any>((resolve: any) => {
      const locationInitialized = this.injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      locationInitialized.then(() => {
        const browserLang = navigator.language;
        // const defaultLang = browserLang.match(/de|en-US/) ? browserLang : 'en-US';
        const defaultLang = browserLang.match(/de/) ? browserLang : 'de';

        this.settings.setLanguage(defaultLang);
        this.translate.setDefaultLang(defaultLang);
        this.translate.use(defaultLang).subscribe(
          () => {
            if (!environment.production) {
              console.log(`Successfully initialized '${defaultLang}' language.'`)
            }
          },
          (reason) => {
            console.error(`Problem with '${defaultLang}' language initialization.'`);
            SentryErrorService.captureException(reason).then();
          },
          () => resolve(null)
        );
      });
    });
  }
}
